import React from "react";

export default function Terms() {
  return (
    <main className="max-w-4xl mx-auto px-6 lg:px-10 py-16" data-testid="terms-page">
      <div className="overline">Legal</div>
      <h1 className="font-serif text-4xl md:text-5xl tracking-tighter mt-3 mb-8">
        Terms &amp; Conditions
      </h1>
      <p className="text-zinc-400 text-sm mb-10">Last updated: August 2026</p>

      <div className="prose prose-invert max-w-none space-y-6 text-zinc-300 leading-relaxed">
        <section>
          <h2 className="font-serif text-2xl gold mb-3">1. About the Atelier</h2>
          <p>
            Jacinto's Culinary Atelier ("the Atelier", "we", "us") is a digital
            platform operated by Chef Jacinto Samuel offering exclusive culinary
            recipes and passes at{" "}
            <a href="https://jacintosculinaryatelier.com" className="gold underline">
              jacintosculinaryatelier.com
            </a>
            . By using our services, you agree to these Terms.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl gold mb-3">2. What You're Buying</h2>
          <p>Every purchase gives you a lifetime digital licence to consult the recipe(s) purchased:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li><b>Individual Recipes</b> — meals £70, desserts £50</li>
            <li><b>Capital Pass</b> — £200, all recipes from a single capital</li>
            <li><b>Grand Tour</b> — £550, the full atelier catalogue</li>
            <li><b>Gift-a-Pass</b> — any of the above, delivered to a recipient</li>
          </ul>
          <p>Prices are in GBP and include applicable digital taxes.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl gold mb-3">3. Personal Use Only</h2>
          <p>
            Recipes are for your <b>personal, non-commercial</b> use. You may cook them
            for yourself, family and private guests. You may <b>not</b> resell, republish,
            translate, publish online or use them in a commercial kitchen without written
            permission from Chef Jacinto Samuel.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl gold mb-3">4. Refunds</h2>
          <p>
            Because recipes are digital goods delivered immediately upon payment, we
            follow the <b>EU Consumer Rights Directive Article 16(m)</b>: once the recipe
            is unlocked, the 14-day withdrawal right does not apply.
          </p>
          <p>
            If you believe there is a genuine error (wrong recipe delivered, technical
            issue that prevents access), contact us within <b>7 days</b> at{" "}
            <a href="mailto:jacintof.samuel@gmail.com" className="gold underline">
              jacintof.samuel@gmail.com
            </a>{" "}
            and we will resolve it fairly.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl gold mb-3">5. Payments</h2>
          <p>
            Payments are processed securely via <b>Stripe</b>. We never store your
            credit-card details. All transactions are in GBP and subject to Stripe's
            terms of service.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl gold mb-3">6. Account &amp; Access</h2>
          <p>
            Access to purchased recipes requires signing in with Google. You are
            responsible for maintaining the confidentiality of your account. Do not
            share your account with third parties.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl gold mb-3">7. Intellectual Property</h2>
          <p>
            All recipes, images, texts and compositions on this Atelier are the
            intellectual property of Chef Jacinto Samuel. Purchase grants a personal
            licence to use — not the right to reproduce, distribute or claim authorship.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl gold mb-3">8. Allergens &amp; Health</h2>
          <p>
            Recipes may contain allergens (nuts, dairy, gluten, shellfish, alcohol,
            etc.). It is your responsibility to review ingredients before cooking. Chef
            Jacinto Samuel is not liable for allergic reactions or adverse health
            effects arising from preparation or consumption.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl gold mb-3">9. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, our total liability for any claim
            arising from your use of the Atelier is limited to the amount you paid for
            the affected recipe or pass.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl gold mb-3">10. Changes &amp; Contact</h2>
          <p>
            We may update these Terms occasionally. Material changes will be posted here.
            For questions, contact{" "}
            <a href="mailto:jacintof.samuel@gmail.com" className="gold underline">
              jacintof.samuel@gmail.com
            </a>
            .
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl gold mb-3">11. Governing Law</h2>
          <p>
            These Terms are governed by the laws of Portugal, without prejudice to
            mandatory consumer-protection provisions of your country of residence within
            the European Union.
          </p>
        </section>
      </div>
    </main>
  );
}
